import { Button } from '../../../Buttons';
import { Card } from '../../../DataDisplay';
import { Group } from '../../../Layout';
import { Text } from '../../../Typography';

type EarnCTAButtonProps = {
  onClick: () => void;
  type: 'online' | 'local';
};

const EarnCTAButton = ({ onClick, type }: EarnCTAButtonProps) => {
  const cardText =
    type === 'online'
      ? 'Never miss Rewards! Use our extension to view and activate offers when you shop.'
      : 'Unlock Rewards Instantly! Add a card to start earning at local favorites.';
  const buttonText = type === 'online' ? 'Get the Extension' : 'Add a Card';

  return (
    <Card radius="md" bg="slate">
      <Group gap="md" align="center" justify="space-between" wrap="nowrap">
        <Text flex="1" type="sub" fw="600" c="white">
          {cardText}
        </Text>
        <Button size="md" onClick={onClick}>
          {buttonText}
        </Button>
      </Group>
    </Card>
  );
};

export { EarnCTAButton };
